import { useMemo } from "react";
import { useSelector } from "react-redux";
import useCheckCallConnected from "../../hooks/useCheckCallConnected";
import useLanguageChange from "../../hooks/useLanguageChange";
import { CALL_DATA, PublicVariables } from "../../constants/PublicVariables";
import { CALL_BODY_SCREEN, ENABLED } from "../../constants/Constants";
import googleEvent from "../../services/googleEvent";
import { EVENT_NAME } from "../../constants/GTagConstants";
import takePhotoService from "../../services/takePhotoService";
import GalleryViewTooltip from "../UI/Tooltip/GalleryViewTooltip";
import useShowGalleryViewTooltip from "../../hooks/useShowGalleryViewTooltip";

const TakePhotoButton = () => {
    const isCallNotConnected = useCheckCallConnected();
    const localisedValues = useLanguageChange();
    const showGalleryViewTooltip = useShowGalleryViewTooltip();
    const { allowTakePhoto, currentCallBodyScreen } = useSelector((state) => state.commonReducer);

    const takePhoto = () => {
        googleEvent.logEvent(EVENT_NAME.TAKE_PHOTO);
        takePhotoService.takePhoto(null);
    };

    const isButtonDisabled = useMemo(() => {
        const btnValue = isCallNotConnected || !allowTakePhoto || currentCallBodyScreen === CALL_BODY_SCREEN.NOTIFY_SCREEN;
        return btnValue;
    }, [isCallNotConnected, allowTakePhoto, currentCallBodyScreen]);

    return (
        <>
            {!CALL_DATA.isObserver && PublicVariables.featureFlag?.SHOWMETAKEPHOTO === ENABLED && (
                <div className='action-button'>
                    <div className='action-button-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width'>
                        <button
                            className='call-action-btn'
                            id='take-photo-button'
                            data-testid='takePhotoButton'
                            disabled={isButtonDisabled}
                            onClick={takePhoto}
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-camera'></span>
                            </span>
                            <span className='for-text'>{localisedValues["take_photo"]}</span>
                        </button>
                        {showGalleryViewTooltip && allowTakePhoto && <GalleryViewTooltip localisedValues={localisedValues} />}
                    </div>
                </div>
            )}
        </>
    );
};

export default TakePhotoButton;
